
import './App.css';
import AppRoutes from './routes/AppRoutes';

function App() {

  return (
    <div className='w-full m-0 p-0 '
      style={{
        backgroundColor: '#f9f9fb',
      }}
    >
      <AppRoutes />
    </div>
  );
}

export default App;
